import { getContext, invoke } from './core';
import { bridgeConfigDelegates } from './bridge-config-delegates';

export const bridgeMethods = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
};
